<div class="dialog">

    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Historia zmian dokumentu' | translate }}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <div *ngIf="loading">
            {{ 'INTERFACE|Trwa ładowanie danych...' | translate }}
        </div>
        <div class="content" *ngIf="!loading">
            <!-- Informacja o ofercie bazowej -->
            <div class="base-offer-info" *ngIf="baseOfferDocument">
                <p>
                    {{ 'SALES_DOCUMENT|Zamówienie na podstawie oferty' | translate }}:
                    <button
                        iccButton
                        appearance="link"
                        (click)="openBaseOffer()"
                        class="base-offer-link"
                    >
                        {{ formatBaseOfferDocument(baseOfferDocument) }}
                    </button>
                </p>
            </div>

            <div id="list-history">
                <header>
                    <span translate>SALES_DOCUMENT|Nazwa zmiany:</span>
                    <span translate>SALES_DOCUMENT|Data i godzina zmiany:</span>
                    <span translate>SALES_DOCUMENT|Autor zmiany:</span>
                    <span translate>SALES_DOCUMENT|Opis zmiany:</span>
                </header>
                <div id="list-history-body">
                    <ng-container *ngFor="let change of changes">
                        <div class="list-history-change list-history-change-main" *ngIf="change.kind === 'main'">
                            <span>{{ change.title }}</span>
                            <span>{{ change.date | date: 'short' }}</span>
                            <span>{{ change.author }}</span>
                            <span>
                                <ng-container *ngIf="change.type !== 'addDoc'">{{ change.description }}</ng-container>
                                <ng-container *ngIf="change.type === 'addDoc' && canOpen.get(change.documentId)">
                                    <button iccButton appearance="secondary" (click)="open(change.documentId)">
                                        {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                                    </button>
                                </ng-container>
                            </span>
                        </div>
                        <div class="list-history-change list-history-change-group" *ngIf="change.kind === 'group'">
                            <span class="list-history-group-shrink" *ngIf="!change.extended">
                                <span translate>SALES_DOCUMENT|Więcej zmian</span>
                                <button iccButton appearance="flat" (click)="change.extended = true" >{{ 'INTERFACE|Rozwiń' | translate }}</button>
                            </span>
                            <div class="list-history-body-group" *ngIf="change.extended">
                                <div class="list-history-change list-history-change-minor" *ngFor="let minorChange of change.group">
                                    <span>{{ minorChange.title }}</span>
                                    <span>{{ minorChange.date | date: 'short' }}</span>
                                    <span>{{ minorChange.author }}</span>
                                    <span>{{ minorChange.description }}</span>
                                </div>
                                <div class="list-history-group-footer">
                                    <button iccButton appearance="flat" (click)="change.extended = false"> {{ 'INTERFACE|Zwiń' | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal width-100">
            <button iccButton (click)="close()" class="right">{{ 'INTERFACE|OK' | translate}}</button>
        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
